import { type QueryFunction, type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import config from "~/config";
import { useApiError } from "~/hooks";
import api from "~/services/api";
import { DocumentType } from "~/services/documents";
import { QueryKey } from "~/utils";
import type { OrgItem } from "../types";

const fetchOrgs: QueryFunction<OrgItem[]> = async () => {
  const body = {
    offset: 0,
    limit: 9999,
    view_rule: {
      "axle.org": {
        src: ["axle.org"],
      },
    },
    document_type: DocumentType.org,
  };

  return api.post<any[]>(config.api.documents.view, body).then(({ data }) =>
    data.map<OrgItem>((d) => ({
      id: d._document?.id,
      name: d["axle.org"]?.name,
      navbarImageUrl: d["axle.org"]?.navbarImageUrl,
    })),
  );
};

type UseAllOrgsSimpleQueryOptions<T> = Omit<UseQueryOptions<OrgItem[], Error, T>, "queryKey" | "queryFn">;

export const useAllOrgsSimpleQuery = <T = OrgItem[]>(queryOptions: UseAllOrgsSimpleQueryOptions<T> = {}) => {
  const { onApiError } = useApiError();

  const query = useQuery({
    queryKey: [QueryKey.Org, "simple"],
    queryFn: fetchOrgs,
    ...queryOptions,
  });

  useEffect(() => {
    if (query.error) {
      onApiError(query.error);
    }
  }, [onApiError, query.error]);

  return query;
};
